import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    airtable_config_get_label, detail_click,
    form_brands_name_change, form_email_change,
    form_policy_change,
    form_subscribe_change, send_form, send_show_empty, signup_click
} from "../redux/actions";
import svg1 from "../images/label-1.svg";
import svg2 from "../images/label-2.svg";
import svg3 from "../images/label-3.svg";


export const CardsEmpty = () => {
    const dispatch = useDispatch()
    const translate = useSelector(state => state.app.translate)

    const subscribe_type = useSelector(state => state.app.subscribe_type)
    const subscribed_brands = useSelector(state => state.app.subscribed_brands)
    const brands = useSelector(state => state.app.brands)
    const airconfig = useSelector(state => state.app.airconfig)
    const app_lang = useSelector(state => state.app.app_lang)
    const formBrandsName = useSelector(state => state.app.formBrandsName)
    const formEmail = useSelector(state => state.app.formEmail)
    const formPolicy = useSelector(state => state.app.formPolicy)
    const formSubscribe = useSelector(state => state.app.formSubscribe)
    const formBrandsNameError = useSelector(state => state.app.formBrandsNameError)
    const formEmailError = useSelector(state => state.app.formEmailError)
    const formPolicyError = useSelector(state => state.app.formPolicyError)
    const formSubmited = useSelector(state => state.app.formSubmited)
    const label1 = airtable_config_get_label(airconfig, 'mobile_tracking_label', app_lang);
    const hint1 = airtable_config_get_label(airconfig, 'mobile_tracking_hint', app_lang);
    const label2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_label', app_lang);
    const hint2 = airtable_config_get_label(airconfig, 'travelpayouts_exclusive_hint', app_lang);
    const label3 = airtable_config_get_label(airconfig, 'hot_deal_label', app_lang);
    const hint3 = airtable_config_get_label(airconfig, 'hot_deal_hint', app_lang);
    const join_link = (brand_id, subscribe_type, subscribed_brands, locale) => {
        const client_id = 'b0e02fcc-0ab4-4b2c-a164-742762783a4e';
        if (subscribe_type === 2) {
            const is_subscribed = (subscribed_brands.indexOf(parseInt(brand_id)) > -1);
            if (is_subscribed) {
                return 'https://app.travelpayouts.com/programs/' + brand_id + '/about&locale=' + locale;
            } else {
                return 'https://app.travelpayouts.com/programs/' + brand_id + '/about?from_landing=true&locale=' + locale;
            }
        } else {
            return 'https://passport.travelpayouts.com/registration?&client_id=' + client_id + '&response_type=code&redirect_uri=https%3A%2F%2Fapp.travelpayouts.com%2Fapi%2Fauth%2Fcallback&scope=offline_access&locale=' + locale + '&return_path=https%3A%2F%2Fapp.travelpayouts.com%2Fprograms%2F' + brand_id + '%2Fabout%3Ffrom_landing%3Dtrue%26locale%3D' + locale;
        }
    }
    const searchValue = useSelector(state => state.app.search)

    const current_category = useSelector(state => state.app.current_category)
    const searchItems = useSelector(state => state.app.searchItems)
    let searchedBrands = [];
    if (searchItems.length > 0) {
        const addedItems = new Map();
        for (let i = 0; i < searchItems.length; i++) {

            if (searchItems[i].fields.cat_id === current_category || current_category === '') {
                if (searchItems[i].fields.Name.toLowerCase().indexOf(searchValue.toLowerCase()) + 1 > 0) {
                    for (let j = 0; j < brands.length; j++) {
                        let name = brands[j].shortName.toLowerCase();
                        let tier1 = searchItems[i]?.fields?.tier_1?.toLowerCase() || null;
                        let tier2 = searchItems[i]?.fields?.tier_2?.toLowerCase() || null;
                        let tier3 = searchItems[i]?.fields?.tier_3?.toLowerCase() || null;

                        if (tier1 && name === tier1 && !addedItems.get(tier1)) {
                            searchedBrands.push(brands[j])
                            addedItems.set(tier1, true)
                        }
                        if (tier2 && name === tier2 && !addedItems.get(tier2)) {
                            searchedBrands.push(brands[j])
                            addedItems.set(tier2, true)
                        }
                        if (tier3 && name === tier3 && !addedItems.get(tier3)) {
                            searchedBrands.push(brands[j])
                            addedItems.set(tier3, true)
                        }
                    }
                }
            }
        }
    }
    if (searchedBrands.length === 0) {
        for (let j = 0; j < brands.length; j++) {
            let name = brands[j].shortName.toLowerCase();
            if (name === 'viator') {
                searchedBrands.push(brands[j])
            }
            if (name === 'wayaway') {
                searchedBrands.push(brands[j])
            }
            if (name === 'booking.com') {
                searchedBrands.push(brands[j])
            }
        }
    }
    const disabled_checked = (p1, p2, p3, p4, p5) => {
        return p1 || p2 || p3 || p4 === '' || p5 === '';
    }

    send_show_empty(searchValue);
    return (
        <div className="emptyPage">
            {
                formSubmited && (
                    <React.Fragment>
                        <div className="emptyPage__heading"
                             dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_form_thank_heading', app_lang)}}/>
                        <div className="emptyPage__description"
                             dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_form_thank_description', app_lang)}}/>
                    </React.Fragment>
                )
            }
            {
                !formSubmited && (
                    <React.Fragment>
                        <div className="emptyPage__heading"
                             dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_heading', app_lang)}}/>
                        <div className="emptyPage__description"
                             dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_description', app_lang)}}/>
                        <form className="emptyPage__form">
                            <div className="emptyPage__row">
                                <input type="text" name="brands_name"
                                       className={(formBrandsNameError ? 'error' : '')}
                                       placeholder={airtable_config_get_label(airconfig, 'empty_form_name', app_lang)}
                                       value={formBrandsName}
                                       onChange={(e) => dispatch(form_brands_name_change(e.target.value))}
                                />
                            </div>
                            <div className="emptyPage__row">
                                <input type="email" name="email"
                                       className={(formEmailError ? 'error' : '')}
                                       placeholder={airtable_config_get_label(airconfig, 'empty_form_email', app_lang)}
                                       value={formEmail}
                                       onChange={(e) => dispatch(form_email_change(e.target.value))}
                                />
                            </div>
                            <div className="emptyPage__row">
                                <button type="submit"
                                        disabled={disabled_checked(formBrandsNameError, formEmailError, formPolicyError, formBrandsName, formEmail)}
                                        onClick={(e) => dispatch(send_form(e, formBrandsName, formEmail, formPolicy, formSubscribe))}
                                >{airtable_config_get_label(airconfig, 'empty_form_btn', app_lang)}</button>
                            </div>
                            <div className="emptyPage__row checkbox">
                                <label className={(formPolicyError ? 'error' : '')}>
                                    <input type="checkbox" name="policy"
                                           value={formPolicy}
                                           defaultChecked={formPolicy}
                                           onChange={() => dispatch(form_policy_change(formPolicy))}
                                    />
                                    <span
                                        dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_form_msg1', app_lang)}}/>
                                </label>
                            </div>
                            <div className="emptyPage__row checkbox">
                                <label>
                                    <input type="checkbox" name="subscribe"
                                           value={formSubscribe}
                                           defaultChecked={formSubscribe}
                                           onChange={() => dispatch(form_subscribe_change(formSubscribe))}
                                    />
                                    <span
                                        dangerouslySetInnerHTML={{__html: airtable_config_get_label(airconfig, 'empty_form_msg2', app_lang)}}/>
                                </label>
                            </div>
                        </form>

                    </React.Fragment>
                )
            }
            {
                searchedBrands.length > 0 && (
                    <div className="emptyPage__cards">
                        <div className="emptyPage__cards_title">
                            {
                                airtable_config_get_label(airconfig, 'empty_cards_title', app_lang)
                            }
                        </div>
                        <div className="cards">
                            {
                                searchedBrands.map((item) => {
                                    let item_class = 'cards__item';
                                    if (item.offerParamsSet.promoPictureUrl !== null) {
                                        item_class += ' cards__item-promo'
                                    }
                                    let label_number = 0;
                                    return (
                                        <div key={`fake_card${item.id}`} className={item_class} id={`item-${item.id}`}
                                             style={{borderColor: item.offerParamsSet.promoBorderColor}}>
                                            <div className="cards__box">
                                                <div className="cards__labels">
                                                    {
                                                        label_number === 1 && (
                                                            <div className="cards__mobile_tracking">
                                                                {label1} <img src={svg1} alt=""/>
                                                                {
                                                                    hint1 && (
                                                                        <div className="cards__mobile_tracking_message">{hint1}</div>
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        label_number === 2 && (
                                                            <div className="cards__exclusive">
                                                                {label2} <img src={svg2} alt=""/>
                                                                {
                                                                    hint2 && (
                                                                        <div className="cards__exclusive_message">{hint2}</div>
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        label_number === 3 && (
                                                            <div className="cards__hot_deal">
                                                                {label3} <img src={svg3} alt=""/>
                                                                {
                                                                    hint2 && (
                                                                        <div className="cards__hot_deal_message">{hint3}</div>
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                </div>

                                                {
                                                    item.landingUrl && (
                                                        <a href={item.landingUrl}
                                                           onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'logo')}
                                                           className="cards__image" target="_blank" rel="noopener">
                                                            <img src={item.iconUrl} alt="" title="" loading="lazy"/>
                                                        </a>
                                                    )
                                                }
                                                {
                                                    !item.landingUrl && (
                                                        <div className="cards__image">
                                                            <img src={item.logoUrl} alt="" title="" loading="lazy"/>
                                                        </div>
                                                    )
                                                }
                                                <div className="cards__title">{item.shortName}</div>
                                                <div className="cards__caption">{item.offerParamsSet.caption}</div>
                                                <div className="cards__params">
                                                    {
                                                        item.offerParamsSet.offerParams.length > 0 && (item.offerParamsSet.offerParams.map((p, index) => {
                                                            return (
                                                                <div className="cards__param" key={index}>
                                                                    <div>
                                                                        {p.value}
                                                                        {
                                                                            p.description !== null && (<div className="cards__hint">
                                                                                <div
                                                                                    className="cards__hint_message">{p.description}</div>
                                                                            </div>)
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                        {p.label}

                                                                    </div>

                                                                </div>)

                                                        }))
                                                    }
                                                </div>
                                                <div className="cards__btns">
                                                    <a href={join_link(item.id, subscribe_type, subscribed_brands, app_lang)}
                                                       onClick={() => signup_click('card', item.shortName, item.id)}
                                                       className="cards__btn1"
                                                       target="_blank" rel="noopener">
                                                        {translate.join_btn}
                                                    </a>
                                                    {
                                                        item.landingUrl && (
                                                            <a href={item.landingUrl}
                                                               onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'button')}
                                                               className="cards__btn2" target="_blank"
                                                               rel="noopener">
                                                                {translate.details_btn}
                                                            </a>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                            {
                                                (item.offerParamsSet.promoPictureUrl !== null) && (
                                                    <a href={item.landingUrl}
                                                       onClick={() => detail_click(item.shortName, item.id, item.landingUrl, 'button')}
                                                       rel="noopener"
                                                       target="_blank"
                                                       className="cards__promo_picture"><img
                                                        src={item.offerParamsSet.promoPictureUrl}
                                                        alt=""
                                                        title=""/></a>
                                                )
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                )
            }


        </div>
    )
}